const mockHotels = [
  {
    id: 1,
    name: "Runway Residency",
    location: "Delhi",
    price: "₹1574 - ₹11799",
    timing: "1:00 AM - 2:00 PM",
    rating: 4.1,
    type: "Flexible Stay (Nappr)",
    image: "https://images.unsplash.com/photo-1566073771259-6a8506099945",
  },
  {
    id: 2,
    name: "Hotel Silver Saffron",
    location: "Delhi",
    price: "₹999 - ₹1499",
    timing: "7:00 AM - 9:00 PM",
    rating: 4.3,
    type: "Popular",
    image: "https://images.unsplash.com/photo-1582719478250-c89cae4dc85b",
  },
  {
    id: 3,
    name: "Hotel Rama Inn",
    location: "Delhi",
    price: "₹749 - ₹949",
    timing: "10:00 AM - 11:00 PM",
    rating: 4.0,
    type: "Budget",
    image: "https://images.unsplash.com/photo-1590490360182-c33d57733427",
  },
  // {
  //   id: 4,
  //   name: "Hotel Sandberry",
  //   location: "Delhi",
  //   price: "₹999 - ₹1499",
  //   timing: "10:00 AM - 11:00 PM",
  //   rating: 4.2,
  //   type: "Flexible Stay (Nappr)",
  //   image: "https://unsplash.com/photos/coconut-palm-trees-in-hotel-lobby-_dS27XGgRyQ",
  // },
  {
    id: 5,
    name: "Hotel Golden Saffron",
    location: "Delhi",
    price: "₹999 - ₹1499",
    timing: "7:00 AM - 9:00 PM",
    rating: 4.5,
    type: "Top Rated",
    image: "https://images.unsplash.com/photo-1551882547-ff40c63fe5fa",
  },
  {
    id: 6,
    name: "Hotel City Empire",
    location: "Delhi",
    price: "₹899 - ₹1199",
    timing: "8:00 AM - 11:00 PM",
    rating: 4.0,
    type: "Budget",
    image: "https://images.unsplash.com/photo-1568495248636-6432b97bd949",
  },
  {
    id: 7,
    name: "Hotel Urban Abode",
    location: "Delhi",
    price: "₹500 - ₹750",
    timing: "7:00 AM - 9:00 PM",
    rating: 4.6,
    type: "Flexible Stay (Nappr)",
    image: "https://images.unsplash.com/photo-1551918120-9739cb430c6d",
  },
];

export default mockHotels;